import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Toolbar from "@mui/material/Toolbar";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import SearchIcon from "@mui/icons-material/Search";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";

// const drawerWidth = 220;

const NavBarGrid = (props) => {
  //#region props
  const {  children, isSidebarOpen } = props;
  const drawerWidth = isSidebarOpen ? 240 : 72;

  //#region variables
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const location = useLocation();
  const [leftNavOptions, setLeftNavOptions] = useState([
    {
      name: "Dashboard",
      icon: <HomeOutlinedIcon sx={{ fontSize: "24px !important",color: "inherit"  }} />,
      path: "/dashboard",
    },
    {
      name: "Documents",
      icon: <FolderOutlinedIcon sx={{ fontSize: "20px !important",color: "inherit"  }} />,
      path: "/documents-history",
    },
    // {
    //   name: "Due Diligence Portfolio",
    //   icon: <WorkOutlineIcon sx={{ fontSize: "20px !important",color: "inherit"  }} />,
    //   path: "/due-diligence",
    // },
    // {
    //   name: "New Spring Capital",
    //   icon: <WorkOutlineIcon sx={{ fontSize: "20px !important",color: "inherit"  }} />,
    //   path: "/new-spring-capital",
    // },
  ]);

  //#region click events
  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const handleMenuClick = (path) => {
    if(path === '/new-spring-capital'){
      window.open(path, '_blank');
    }
    else{
      navigate(path);
    }
  };

  //#region render functions
  const drawer = (
    <div>
      {/* <div className='child-margin-5 padding-10'>
        <b>New Spring</b>
        <div>{secureLocalStorage.getItem("fullName")}</div>
      </div> */}
      <Divider />
      <List>
        {leftNavOptions?.map((option, index) => (
          <ListItem
            key={index}
            disablePadding
            onClick={() => handleMenuClick(option.path)}           
          >
            <ListItemButton
              className={location.pathname.startsWith(option.path) ? "nav-active" : ""}
               sx={{
              px: 2,
              borderRadius: 1,
              display: "flex",
              alignItems: "center",
              transition: "all 0.3s ease",
              color: location.pathname.startsWith(option.path) ? "#fff" : "#1F61C5",
              bgcolor:
                location.pathname.startsWith(option.path) ? "#1F61C5" : "transparent",
              "&:hover": {
                bgcolor: "#789dd8ff",
                color: "#fff",
                "& .MuiListItemIcon-root": {
                  color: "#fff",
                },
              },
            }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 34,
                  color: "inherit", 
                  transition: "color 0.3s ease",
                }}
              >
                {option.icon}
              </ListItemIcon>
              {isSidebarOpen && <ListItemText primary={option.name} sx={{ color: "inherit" }}  />}
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  // Remove this const when copying and pasting into your project.
  const container =
    typeof window !== 'undefined' ? () => window.document.body : undefined;

  //#region return
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Box
        component="nav"
        sx={{
          width: { sm: drawerWidth },
          flexShrink: { sm: 0 },
          boxShadow: "none",
        }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              transition: "width 0.3s ease",
            },
          }}
        >
          {drawer}
        </Drawer>
        {/* DESKTOP DRAWER */}
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              position: "fixed",
              top: 64,
              height: "calc(100% - 64px)",
              transition: "width 0.3s ease",
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
        {children}
      </Box>
    </Box>
  );
};

NavBarGrid.propTypes = {
  window: PropTypes.func,
};

export default NavBarGrid;
